import type { UserRole } from '@/types/role';

/** Role codes from the roles table (R1–R7). */
export const ROLE_CODES = {
  SYSTEM_ADMIN: 'R1',
  COMPLIANCE_MANAGER: 'R2',
  CISO: 'R3',
  CONTROL_OWNER: 'R4',
  INTERNAL_AUDIT_LEAD: 'R5a',
  INTERNAL_AUDIT_MEMBER: 'R5b',
  EXTERNAL_AUDITOR: 'R6',
  EMPLOYEE: 'R7',
} as const;

export type RoleCode = (typeof ROLE_CODES)[keyof typeof ROLE_CODES];

export const USER_ROLE_BY_CODE: Record<RoleCode, UserRole> = {
  R1: 'System Administrator',
  R2: 'Compliance Manager',
  R3: 'CISO',
  R4: 'Control Owner',
  R5a: 'Internal Audit Lead',
  R5b: 'Internal Audit Member',
  R6: 'External Auditor',
  R7: 'Employee',
};

export const ROLE_CODE_BY_USER_ROLE: Record<UserRole, RoleCode> = {
  'System Administrator': 'R1',
  'Compliance Manager': 'R2',
  CISO: 'R3',
  'Control Owner': 'R4',
  'Internal Audit Lead': 'R5a',
  'Internal Audit Member': 'R5b',
  'External Auditor': 'R6',
  Employee: 'R7',
};
